import React from 'react';
import { useNavigate } from 'react-router-dom';
import SecurityView from './security-view';

const SecurityContainer = () => {
  const navigate = useNavigate();

  const handleNavigateBack = () => {
    navigate('/account');
  };

  return (
    <SecurityView onNavigateBack={handleNavigateBack} />
  );
};

export default SecurityContainer;
